(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-slider')) {
    class FeaturedCollectionSlider extends HTMLElement {
      connectedCallback() {
        if (typeof window.Swiper === 'undefined') {
          window.addEventListener('load', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.swiper || typeof window.Swiper === 'undefined') return;

        const el = this.querySelector('.swiper');
        if (!el) return;

        const { slidesDesktop, slidesMobile, spaceBetween } = this.dataset;
        const gap = parseInt(spaceBetween, 10) || 0;

        this.swiper = new window.Swiper(el, {
          slidesPerView: parseFloat(slidesMobile) || 1.5,
          spaceBetween: Math.round(gap / 2),
          watchOverflow: true,
          observer: true,
          observeParents: true,
          navigation: {
            // Scoped to this instance so multiple sliders on a page don't cross-wire
            prevEl: this.querySelector('[data-prev]'),
            nextEl: this.querySelector('[data-next]'),
            disabledClass: 'is-disabled',
            lockClass: 'is-locked',
          },
          breakpoints: {
            750: {
              slidesPerView: parseFloat(slidesDesktop) || 4,
              spaceBetween: gap,
            },
          },
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }

    customElements.define('featured-collection-slider', FeaturedCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
